import ReportEditConfigController from '../ATReportEditConfigController'
import {Feature, isEnabled} from '../../../features'
import {ReportGroupingLevel} from '../../constants'
import $ from 'jquery'
import {StaffPerformanceColumnsConfig} from 'constants'
import StaffoutputColumnsFormatSelector from '../../../controls/StaffoutputColumnsFormatSelector'
import ThreeLevelReportGroupingSelector from '../../ThreeLevelReportGroupingSelector'
import SimpleTooltip from '../../../SimpleTooltip'
import messageResource from '../../../messageResource'
import CustomCheckbox from '../../../components/customCheckbox/CustomCheckbox'
import {formatLFM} from '../../../util/UserNameFormat'

export default class StaffOutputReportEditConfigController extends ReportEditConfigController {}

StaffOutputReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    const self = this;
    this.reportAuthorizationInfo = config.reportAuthorizationInfo
    this.showUserSelector = this.reportAuthorizationInfo.anyOtherUsersAvailable || this.reportAuthorizationInfo.allUsersAvailable

    const reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);

    this.configChangedCallback = config.changeCallback;
    const configChanged = function () { self.configChanged(); };
    
    // if feature enabled otherwise only if value is not "users only" - show selector
    this.columnFormatSelector = this.addColumnFormatFilter(reportParameters.columnsConfig, configChanged);

    // if feature enabled otherwise only if value is not "both" - show selector
    this.approvedTTFilter = this.addApprovedTTFilter(reportParameters.timeApprovalStatus, configChanged);


    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    const groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];
    this.groupingSelector = new ThreeLevelReportGroupingSelector().init( {
        selectorId: "reportGroupingSelector",
        enableNoneFirstGrouping: false,
        enableGroupByBillingType: isEnabled(Feature.BTY) || this.checkGroupingLevel(ReportGroupingLevel.BILLING_TYPE, groupingLevelsSelection),
        enableGroupByUsers: false,
        enableGroupByUserGroups: false,
        includeTTCommentsInDetailsLevel: false,
        groupingLevelsSelection: groupingLevelsSelection,
        changesCallback: function() {
            self.removeGroupingLevelsSelectionError();
            configChanged();
        }
    });

    // if feature enabled or checkbox is selected
    if ( this.verifyIsShowLeavesCheckbox(reportParameters) ) {
        $("#leavesCheckbox").show();
        this.showLeaveTimeChexbox = $( "#showLeavesCheckbox" );
        this.showLeaveTimeChexbox.prop( "checked", reportParameters.showLeaveTime );
        this.showLeaveTimeChexbox.on("change", configChanged);
    }

    const $usernameLabel = $('.usernameLabel')
    $usernameLabel.toggle(!this.showUserSelector)

    if (this.showUserSelector)
        this.userSelector = this.makeUserSelector({
            ...config,
            allUsersAvailable: config.reportAuthorizationInfo.allUsersAvailable
        })
    else {
        $('#userSelectorId').hide()
        const user = config.users[0]
        const usernameFormatted = formatLFM(user.firstName, user.lastName, user.middleName, ", ")
        $usernameLabel.text(usernameFormatted)
    }

    this.makeShowOtherUsersCheckbox(reportParameters.includeOtherUsersColumn, configChanged)

    return this;
};

/**
 * add column format filter if need
 * @param initValue
 * @param onChangeCallback
 * @returns {{getValue, setActiveItemByValue}}
 */
StaffOutputReportEditConfigController.prototype.addColumnFormatFilter = function( initValue, onChangeCallback) {
    const ifNeedColumnFormatSelector = (isEnabled(Feature.UGR) || isEnabled(Feature.TZG)|| (initValue !== StaffPerformanceColumnsConfig.USERS_ONLY))
    const $columnsFormatFilter = $("#columnsFormatFilterRow");
    if (ifNeedColumnFormatSelector){
        $columnsFormatFilter.show();
        return new StaffoutputColumnsFormatSelector().init("columnsDisplayFormat", initValue, onChangeCallback);
    } else {
        $columnsFormatFilter.hide();
        return this.initEmptyListSelector(initValue);
    }
};

StaffOutputReportEditConfigController.prototype.makeShowOtherUsersCheckbox = function (includeOtherUsersColumn, onChangeCallback) {
    const $checkboxContainer = $(".showOtherUsersCheckboxRow")
    $checkboxContainer.toggle(!this.reportAuthorizationInfo.allUsersAvailable)

    if (!this.reportAuthorizationInfo.allUsersAvailable) {
        const labelText = this.reportAuthorizationInfo.anyOtherUsersAvailable ?
                          messageResource.getMessage('report.common.include_not_assigned_users') :
                          messageResource.getMessage('report.common.include_other_users')

        this.showOtherUsersCheckbox = new CustomCheckbox({
            label: labelText,
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
            onChange: () => onChangeCallback()
        }).init($checkboxContainer)

        this.showOtherUsersCheckbox.setState({checked: includeOtherUsersColumn})

        this.showOtherUsersCheckboxTooltip = new SimpleTooltip({
            text: messageResource.getMessage('report.common.show_other_users_checkbox_tooltip_text'),
        }).init($('body'))
        this.showOtherUsersCheckboxTooltip.subscribeToMouseEvents(this.showOtherUsersCheckbox.getEl())

        this._updateIncludeOtherUsersCheckbox()
    }
};

StaffOutputReportEditConfigController.prototype._updateIncludeOtherUsersCheckbox = function() {
    if (this.showOtherUsersCheckbox) {
        const disabled = !!this.userSelector && this.userSelector.getSelection().allUsers !== true
        this.showOtherUsersCheckbox.setState({
            checked: !disabled && this.showOtherUsersCheckbox.isChecked(),
            disabled
        })

        this.showOtherUsersCheckboxTooltip.setEnabled(disabled)
    }
}

StaffOutputReportEditConfigController.prototype.updateUI = function (blinkError) {
    ReportEditConfigController.prototype.updateUI.call(this, blinkError)
    this._updateIncludeOtherUsersCheckbox()
};

StaffOutputReportEditConfigController.prototype.verifyIsShowLeavesCheckbox = function ( reportParameters ) {
    return this.reportAuthorizationInfo.leavesAvailable && (isEnabled(Feature.LVT) || reportParameters.showLeaveTime);
};

StaffOutputReportEditConfigController.prototype.getConfig = function () {
    const groupingLevelValues = this.groupingSelector.getValues();
    const needSwitchToMe = !this.showUserSelector
    return {
        columnsConfig: this.columnFormatSelector.getValue(),
        timeFormat: this.timeFormatSelector.getValue(),
        timeApprovalStatus: this.approvedTTFilter.getValue(),
        userSelection: this.showUserSelector ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        showLeaveTime: !!this.showLeaveTimeChexbox && this.showLeaveTimeChexbox.is(":checked"),
        includeOtherUsersColumn: !!this.showOtherUsersCheckbox && this.showOtherUsersCheckbox.isChecked(),
        needSwitchToMe: needSwitchToMe,
    };
};

StaffOutputReportEditConfigController.prototype.resetConfig = function () {
    this.columnFormatSelector.setActiveItemByValue(this.initReportParameters.columnsConfig, true);    
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);    
    this.approvedTTFilter.setActiveItemByValue(this.initReportParameters.timeApprovalStatus, true);

    if (this.showUserSelector)
        this.userSelector.setSelection(this.initReportParameters.userSelection)

    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    if(this.showLeaveTimeChexbox){
        this.showLeaveTimeChexbox.prop("checked", this.initReportParameters.showLeaveTime);
    }
    if(this.showOtherUsersCheckbox){
        this.showOtherUsersCheckbox.setState({checked: this.initReportParameters.includeOtherUsersColumn});
    }
};

StaffOutputReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);
    
    if(this.showUserSelector){
        this.userSelector.setInitialValueFromCurrent();
    }
    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

StaffOutputReportEditConfigController.prototype.validate = function()
{
    this.errors = [];

    if (this.showUserSelector && !this.userSelector.validateIsUserSelected())
        this.errors.push(this.possibleErrors.ERROR_EMPTY_USER_SELECTION)

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

StaffOutputReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    const errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find( "#userSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};

StaffOutputReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function( reportParameters ){
    return reportParameters;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/staffOutput/StaffOutputReportEditConfigController.js